import { HandPalm, HandsClapping, HandWaving } from "phosphor-react";
import { Activity } from "../types";
import { getTeamname } from "../utils";

const Tag = ({
  claimedBy,
  status,
}: {
  status: string;
  claimedBy: string | null;
}) => {
  switch (status) {
    case "available":
      return <HandWaving size={45} />;
    case "claimed":
      return (
        <>
          <span className="activity-claimed-by-text">{claimedBy && getTeamname(claimedBy)}</span>{" "}
          <HandPalm size={45} />
        </>
      );
    case "finished":
      return (
        <>
          <span className="activity-claimed-by-text">{claimedBy && getTeamname(claimedBy)}</span>{" "}
          <HandsClapping size={45} />
        </>
      );
  }
  return <label></label>;
};

function ActivityItem({
  activity,
  onClick,
}: {
  activity: Activity;
  onClick: () => void;
}) {
  const { title, points, claimedBy, status } = activity;
  return (
    <button className="activity-container button" onClick={onClick}>
      <div className="activity-title">{title}</div>
      <Tag claimedBy={claimedBy} status={status} />
      <div className="activity-points">{points}</div>
    </button>
  );
}

export default ActivityItem;
